<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>资产转移单&nbsp;&nbsp;说明:</h5><br>
				<span>1、批量转移、个别物品转移、只影响库存相关数据。操作相当于一个单据=出库单+收货单，针对同一个业务人员的情景。</span><br>
				<span class="red">2、全部转移:一键写入当前选择仓库下所有库存数据</span><br>
				<span class="red">3、查询关键字:业务单号、出仓名称、入仓名称、转移日期、车队</span><br>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_tan_button">
				<button @click="edit_mode">全部转出</button>
			</template>

		</pre-base>
		<!-- 
		<editmode-tan ref="itemmode"></editmode-tan> -->

	</div>
</template>

<script>
	import api from '@/utils/type.js';

	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';


	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "store_from_to",
					"title": "转移单",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_store_car_storefromto',
					"upd_action": 'exp15_store_car_storefromto',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "1",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": 'exp_store_car_storefromto_d',
					"d_upd_action": 'exp15_store_car_d_storefromto',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "业务编号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "出仓",
							"val": "",
							"key": "from_store",
							"type": "select",
							"class": "long2",
							"sel_action": "_base_storecar",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "入仓",
							"val": "",
							"key": "in_store",
							"type": "select",
							"class": "long2",
							"sel_action": "_base_storecar2",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "转移日期",
							"val": "",
							"key": "in_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "车队",
							"val": "",
							"key": "team",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_teamname",
							"sel_name": ""
						}
					],
					"parm": [{
							"name": "业务编号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "出仓",
							"val": "",
							"key": "out_store",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_storecar",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "入仓",
							"val": "",
							"key": "in_store",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_storecar2",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "转移日期",
							"val": "",
							"key": "in_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "2"
						},
						// {
						//   "name": "总金额",
						//   "val": "",
						//   "key": "amount",
						//   "type": "number",
						//   "class": "long1",
						//   "p": "0",
						//   "w": "0",
						//   "r": "1",
						//   "x": "2"
						// },
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "引入模板",
							"val": "",
							"key": "item_mode",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_itemmode",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						}
					],
					"parm_th": [{
							"name": "序号"
						}, 
						{
							"name": "单号"
						},
						{
							"name": "关联业务"
						},
						{
							"name": "出仓"
						},
						{
							"name": "入仓"
						},
						{
							"name": "总金额"
						},
						{
							"name": "转移日期"
						},
						{
							"name": "备注"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [{
							"name": "业务编号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						}, {
							"name": "物品编码",
							"val": "",
							"key": "item_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "1",
						},
						{
							"name": "转移数量",
							"val": "",
							"key": "qty",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1",
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "编号"
						},
						{
							"name": "名称"
						},
						{
							"name": "规格"
						},
						{
							"name": "单位"
						},
						{
							"name": "数量"
						},
						{
							"name": "备注"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					]

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: function() {

				console.log(this.item);

				let sheet_no = '';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'sheet_no') {
						sheet_no = this.item[i].val;
					}
				}

				if (sheet_no === 'undefined' || String(sheet_no) == '') {
					this.$message({
						message: '请先保存主单据信息,确认转出仓库后再点 全部转出 按钮!',
						type: 'warning'
					});
					return
				}

				let d = [];
				d.push(sheet_no);

				let r = (Math.random() + '').substring(0, 8);

				var that = this;
				this.$post(
					api.http_method, Method_Common('_store_car_d_all_storefromto', 0, '', d, r)
				).then(res => {
					res = JSON.parse(res);
					console.log(res);

					if (res.data.status == '1') {
						this.$nextTick(function() {
							that.$refs['mybase'].fun_d_load();
						});
					}
				});




			},



		}
	};
</script>
<style>
</style>
